import React, {Component} from 'react';
import Form from "react-bootstrap/es/Form";
import FormGroup from "react-bootstrap/es/FormGroup";
import ControlLabel from "react-bootstrap/es/ControlLabel";
import Col from "react-bootstrap/es/Col";
import {bindActionCreators} from "redux";
import {fetchIndiviualInfo} from '../../actions/kyc';
import branches from '../../data/branches-std-only';
import {connect} from "react-redux";
import FormControl from 'react-bootstrap/es/FormControl';
import InputGroup from 'react-bootstrap/es/InputGroup';
import Button from 'react-bootstrap/es/Button';
import Row from 'react-bootstrap/es/Row';
import ButtonGroup from 'react-bootstrap/es/ButtonGroup';
import Table from 'react-bootstrap/es/Table';
import {saveApplication, submitApplication, additionalProductChange} from '../../actions/tpfaActions';
import Glyphicon from 'react-bootstrap/es/Glyphicon';
import ButtonsComponent from '../ButtonsComponent';
import _ from 'lodash';
import Alert from 'react-bootstrap/lib/Alert';
import Modal from 'react-bootstrap/lib/Modal';
import {fetchBolProfiles} from '../../actions/bol';


class ThirdPartyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newAccount: {
                accountName: '',
                accountBranch: '',
                idType: '',
                idNumber: '',
                tpName: '',
                tpAddress: {
                    line1: null,
                    line2: null,
                    line3: null,
                    postalCode: null
                }
            },
            tpErrors: [],
            errors: [],
            submittingErrors: [],
            submitting: false,
            tpAddresses: null,
            searching: false
        };

    }

    componentDidMount() {
        this.props.actions.fetchBolProfiles(this.props.application.cif);
    }

    handleAdditionalProduct = (product, change) => {
        let {application: {additionalProducts}, actions} = this.props;
        additionalProducts = additionalProducts ? additionalProducts : {};
        additionalProducts[product] = change;
        actions.additionalProductChange(additionalProducts);
    };

    handleUserChange = ({target}) => {
        const {newAccount} = this.state;
        const {name, value} = target;
        newAccount[name] = value;
        this.setState({newAccount});
    };
    handleAddressChange = ({target}) => {
        const {newAccount, newAccount: {tpAddress}} = this.state;
        const {name, value} = target;
        tpAddress[name] = value;
        newAccount.tpAddress = tpAddress;
        this.setState({newAccount});
    };
    handleSelectAddress = ({target}) => {
        const {newAccount} = this.state;
        const {value} = target;
        newAccount.tpAddress = JSON.parse(value);
        this.setState({newAccount});
    };
    checkID = () => {
        const {newAccount} = this.state;
        let check = newAccount.idType === 'Identity Document';
        return !(check && (newAccount.idNumber && newAccount.idNumber.length === 13));
    };
    handleIDLookup = () => {
        const {newAccount, newAccount: {idNumber}} = this.state;
        const {actions} = this.props;
        this.setState({searching: true});
        let tpAddresses = [];
        const onFinish = (success, person) => {
            if (success) {
                newAccount.tpName = `${person.firstName} ${person.lastName}`;
                tpAddresses = person.addresses;
            }
            this.setState({searching: false, newAccount, tpAddresses});
        };
        actions.fetchIndiviualInfo(idNumber, onFinish, null);
    };

    checkAccountDetails = () => {
        const {newAccount: {accountName, accountBranch, idType, idNumber, tpName}} = this.state;
        const check1 = (accountName && accountBranch && idType);
        const check2 = (idNumber && tpName);
        return !(check1 && check2);
    };

    handleAddAccount = (e) => {
        e.preventDefault();
        const tpErrors = [];
        const {newAccount} = this.state;
        const {actions, application, id} = this.props;
        const accounts = application.accounts ? application.accounts : [];
        this.checkAccountDetails() && tpErrors.push(
            <span>Complete the <strong>Account details</strong> before saving.</span>);
        if (!_.isEmpty(tpErrors)) {
            this.setState({tpErrors});
        } else {
            this.setState({tpErrors, errors: []});
            accounts.push(newAccount);
            application.accounts = accounts;
            actions.saveApplication(application, id, true);
            _.defer(() => this.setState({
                newAccount: {
                    accountName: '',
                    accountBranch: '',
                    idType: '',
                    idNumber: '',
                    tpName: '',
                    tpAddress: {
                        line1: null,
                        line2: null,
                        line3: null,
                        postalCode: null
                    }
                },
                tpAddresses: null
            }));
            e.target.reset();
        }
    };
    handleDeleteAccount = (accountId) => {
        const {actions, application, application: {accounts}, id} = this.props;
        accounts.splice(accountId, 1);
        application.accounts = accounts;
        actions.saveApplication(application, id, true);
    };

    handleNext = () => {
        const {history, actions, application} = this.props;
        this.setState({errors: []});
        // actions.submitApplication();
        _.isEmpty(application.accounts) ? this.setState({errors: [<span>Add accounts before proceeding</span>]}) :
            this.setState({submitting: true});
    };

    handleCheckApplication = () => {
        const {application: {additionalProducts}} = this.props;
        const submittingErrors = [];
        if (additionalProducts) {
            additionalProducts.businessOnlineProfile
                ? _.isEmpty(additionalProducts.businessOnlineProfile) ? submittingErrors.push(
                <span>Please provide/choose a <strong>Business online Profile</strong>.</span>) : false
                : submittingErrors.push(
                <span>Please provide/choose a <strong>Business online Profile</strong>.</span>);
            additionalProducts.cashMan
                ? _.isEmpty(additionalProducts.cashMan) ?
                submittingErrors.push(<span>Please provide a <strong>Cashman Group Number</strong>.</span>) : false
                : submittingErrors.push(<span>Please provide a <strong>Cashman Group Number</strong>.</span>);
        } else {
            submittingErrors.push(<span>Please provide/choose a <strong>Business online Profile and a CashMan Group Number</strong>.</span>);
        }

        _.isEmpty(submittingErrors) ? this.handleSubmit() : this.setState({submittingErrors});
    };

    handleSubmit = () => {
        const {application, id, history} = this.props;
        this.setState({submitting: false});
        this.props.actions.submitApplication(id, application, history);
    }

    bolProfles = () => {
        const {profiles, application: {additionalProducts}} = this.props;
        const profilesOptions = [];
        profiles.forEach((entity) => {
            entity.divisions.forEach((div) => {
                profilesOptions.push({'value': div.code, 'label': `${div.code}: ${div.name}`})
            })
        });
        return (
            <select className={'form-control'} id={'bol'}
                    onChange={({target: {value}}) => this.handleAdditionalProduct("businessOnlineProfile", value)}
                    value={additionalProducts ? additionalProducts.businessOnlineProfile : ""}>
                <option value={''}>-SELECT-</option>
                {
                    profilesOptions.map(profile =>
                        <option key={profile.value} value={profile.value}>{profile.label}</option>
                    )
                }
            </select>
        )
    };

    renderAccount = () => {
        const {newAccount, searching, tpErrors} = this.state;
        const enterName = newAccount.idType !== 'Passport';
        return (
            <Row>
                <Form onSubmit={this.handleAddAccount}>
                    <Col md={7} mdOffset={2}>
                        <h3>Account Details</h3>
                        <FormGroup>
                            <Row>
                                <ControlLabel>Account Name</ControlLabel>
                            </Row>
                            <FormControl type='text' name='accountName'
                                         onChange={this.handleUserChange}/>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <ControlLabel>Account Branch</ControlLabel>
                            </Row>
                            <FormControl componentClass='select' placeholder='SELECT' name='accountBranch'
                                         onChange={this.handleUserChange}>
                                <option value=''>SELECT</option>
                                {
                                    branches.map(branch => <option key={branch.centreNumber}
                                                                   value={branch.centreNumber}>{`${branch.centreName}`}</option>)
                                }
                            </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <ControlLabel>Third Party ID Type</ControlLabel>
                            </Row>
                            <FormControl componentClass='select' placeholder='SELECT' name='idType'
                                         onChange={this.handleUserChange}>
                                <option value=''>SELECT</option>
                                <option value="Identity Document">Identity Document</option>
                                <option value="Passport">Passport</option>
                            </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <ControlLabel>Third Party Identity Number</ControlLabel>
                            </Row>
                            <InputGroup>
                                <input type="text" name="idNumber" onChange={this.handleUserChange}
                                       className="form-control"/>
                                <InputGroup.Button>
                                    <Button disabled={this.checkID()}
                                            onClick={this.handleIDLookup}>{searching ? 'Searching' : 'Search'}</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <ControlLabel>Third Party Name</ControlLabel>
                            </Row>
                            <FormControl type='text' name='tpName' disabled={enterName}
                                         value={newAccount.tpName}
                                         onChange={this.handleUserChange}/>
                        </FormGroup>
                        <div>
                            {
                                !_.isEmpty(tpErrors) && tpErrors.map((error, i) =>
                                    <Alert key={i} bsStyle={'danger'}>{error}</Alert>
                                )
                            }
                        </div>
                        <ButtonGroup>
                            <Button bsStyle={'primary'} type={'submit'}>Save</Button>
                        </ButtonGroup>
                    </Col>
                </Form>
            </Row>
        )
    };

    renderTable = () => {
        const {application} = this.props;
        const accounts = application.accounts ? application.accounts : [];
        return (
            <Row>
                <Col md={12}>
                    <Table responsive striped>
                        <thead>
                        <tr>
                            <th>Account Name</th>
                            <th>Account Branch</th>
                            <th>Third Party ID Type</th>
                            <th>Third Party ID Number</th>
                            <th>Third Party Name</th>
                            <th>Verify</th>
                            <th>Delete</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            accounts.map((account, i) =>
                                <tr key={i}>
                                    <td>{account.accountName}</td>
                                    <td>{account.accountBranch}</td>
                                    <td>{account.idType}</td>
                                    <td>{account.idNumber}</td>
                                    <td>{account.tpName}</td>
                                    <td><input type='checkbox'/></td>
                                    <td><Button onClick={() => this.handleDeleteAccount(i)}><Glyphicon
                                        glyph={'trash'}/></Button></td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
                </Col>
            </Row>
        )
    };

    render() {
        const {errors, submitting, submittingErrors} = this.state;
        const {application, profiles} = this.props;
        const {additionalProducts} = application;
        return (
            <div className='container-fluid'>
                <Col sm={12}>
                    {this.renderAccount()}
                    <hr/>
                    {this.renderTable()}
                    <div>
                        {
                            errors &&
                            errors.map(error =>
                                <Alert bsStyle={'danger'}>{error}</Alert>
                            )
                        }
                    </div>
                    <div>
                        <ButtonsComponent
                            onSaveAndContinue={() => this.props.history.replace('/')}
                            onNext={this.handleNext}
                            hidePrevious={false}
                        />
                    </div>
                </Col>
                <Modal show={submitting} onHide={() => this.setState({submitting: false})}>
                    <Modal.Header>
                        <h4>Before submitting</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            submittingErrors && submittingErrors.map((error, index) => <Alert key={index}
                                                                                              bsStyle={'danger'}>{error}</Alert>)
                        }
                        <div>
                            <ControlLabel>Business Online Profile</ControlLabel>
                            {
                                profiles && profiles.length > 0 ?
                                    this.bolProfles() :
                                    <FormControl type={'text'} id={'bol'} placeholder={'Business online Profile ID'}/>
                            }
                        </div>
                        <br/>
                        <div>
                            <ControlLabel>Cashman Group Number</ControlLabel>
                            <FormControl type={'text'} id={'cashman'}
                                         onChange={({target: {value}}) => this.handleAdditionalProduct("cashMan", value)}
                                         placeholder={'Cashman Group Number'}
                                         value={additionalProducts ? additionalProducts.cashMan : ""}/>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonGroup>
                            <Button onClick={() => this.setState({submitting: false})}>Cancel</Button>
                            <Button bsStyle={'primary'} onClick={this.handleCheckApplication}>Submit</Button>
                        </ButtonGroup>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

}


function mapStateToProps({tpfa: {id, application}, bol: {profiles}, impersonation, loading}) {
    return {
        id,
        application,
        loading,
        profiles,
        impersonation: impersonation && impersonation.impersonation ? impersonation.impersonation : {},
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            fetchIndiviualInfo, saveApplication,
            submitApplication, additionalProductChange, fetchBolProfiles
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdPartyDetails);
